<template>
  <div class="box aaaaa">
    <div class="bbbbb">
      <div class="search">
        <el-form label-width="120px" label-height="60px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="申请开票时间">
                <el-date-picker style="width: 100%" @change="changeTime" v-model="dataRange" type="datetimerange"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :default-time="['', '23:59:59']">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户名称" prop="memberName">
                <el-input style="width: 100%" v-model="queryInfo.condition.memberName" placeholder="请输入"
                          clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发票类型">
                <el-select style="width: 100%" v-model="queryInfo.condition.type" placeholder="请选择" clearable>
                  <el-option label="企业" :value="1"></el-option>
                  <el-option label="个人" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="订单状态">
                <el-select
                  v-model="queryInfo.condition.isAnonymous"
                  placeholder="请选择"
                  @change="orderStatusChange"
                  clearable
                >
                  <el-option label="是" :value="2"> </el-option>
                  <el-option label="否" :value="1"> </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="8"></el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="联系邮箱：" prop="email">
                <el-input style="width: 100%" v-model="queryInfo.condition.email" placeholder="请输入"
                          clearable></el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <el-form-item label="开票状态">-->
<!--                <el-select style="width: 100%" v-model="queryInfo.condition.status" placeholder="请选择" clearable>-->
<!--                  <el-option label="待开票" :value="1"></el-option>-->
<!--                  <el-option label="已开票" :value="2"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

            <el-col :span="8" >
              <el-form-item label-width="20px">
                <el-button @click="reset" icon="el-icon-refresh-left">重置</el-button>
                <el-button type="primary" @click="search" icon="el-icon-search">搜索</el-button>
              </el-form-item>

            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 表格部分 -->

      <el-tabs v-model="activeName" @tab-click="handleClick" class="search_tab">

        <el-tab-pane :label="'全部发票' " :name="null"></el-tab-pane>
        <el-tab-pane :label="'待开票'" name="1"></el-tab-pane>
        <el-tab-pane :label="'已开票'" name="2"></el-tab-pane>

        <!--        <el-tab-pane :label="'全部发票' + '(' + allNumObj.all ? allNumObj.all : 0  + ')' " name="1"></el-tab-pane>-->
        <!--        <el-tab-pane :label="'待开票' + '(' +allNumObj.pending ? allNumObj.pending : 0 + ')'" name="0"></el-tab-pane>-->
        <!--        <el-tab-pane :label="'已开票' + '(' +  allNumObj.success ? allNumObj.success : 0 + ')'" name="2"></el-tab-pane>-->
      </el-tabs>
      <div class="tab">
        <!--      <div class="add">-->
        <!--        <div>全部发票（{{ allNumObj.all ? allNumObj.all : 0 }}）</div>-->
        <!--        <div>待开票（{{ allNumObj.pending ? allNumObj.pending : 0 }}）</div>-->
        <!--        <div>已开票（{{ allNumObj.success ? allNumObj.success : 0 }}）</div>-->
        <!--      </div>-->

        <!--        :header-cell-style="{-->
        <!--        'background-color': '#f2f2f2',-->
        <!--        'text-align': 'center',-->
        <!--        border: '1px solid #ddd',-->
        <!--        }-->

        <el-table :data="tableData" style="width: 100%" height="calc(100vh - 340px)" border v-loading="loading">
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="teamPicture" label="用户名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
          </el-table-column>
          <el-table-column prop="memberCode" label="开票金额" align="center" show-overflow-tooltip>
            <template slot-scope="scope">¥{{ scope.row.invoiceAmount }}</template>
          </el-table-column>

          <el-table-column label="开票单位类型" align="center" show-overflow-tooltip width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">企业</span>
              <span v-if="scope.row.type == 2">个人</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerCount" label="联系地址邮箱" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.email }}</template>
          </el-table-column>
          <el-table-column prop="orderCount" label="申请开票时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.createTime }}</template>
          </el-table-column>
          <el-table-column prop="status" label="开票状态" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">待开票</span>
              <span v-if="scope.row.status == 2">已开票</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="orderStatus"
            label="订单状态"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.orderStatus == 1">待发货</span>
              <span v-if="scope.row.orderStatus == 2">待配送</span>
              <span v-if="scope.row.orderStatus == 3">配送中</span>
              <span
                v-if="
                  scope.row.status == 4 ||
                  scope.row.status == 5 ||
                  scope.row.status == 6 ||
                  scope.row.status == 7
                "
                >已完成</span
              >
              <span v-if="scope.row.status == 8">已评价</span>
            </template>
          </el-table-column> -->
          <el-table-column prop=" " label="操作" width="300" fixed="right" align="center">
            <template slot-scope="scope">
              <el-row type="flex" justify="start">
                <el-button type="text" @click="edit(scope.row.invoiceCode)">编辑</el-button>
                <el-button type="text" @click="orderListdetail(scope.row.invoiceCode)">订单信息</el-button>
                <el-button type="text" @click="toExport(scope.row)" size="small"
                           style="font-size: 12px; padding: 0px">导出
                </el-button>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page.sync="queryInfo.currPage" :page-size="queryInfo.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 发票弹窗 -->
    <el-dialog title="发票详情" :visible.sync="dialogVisible" width="50%" @close="handleClose">
      <el-form :model="form" label-width="92px" label-position="left" class="setform">
        <el-row :gutter="20">
          <el-row :gutter="40">
            <el-col :span="24">
              <el-form-item label="发票信息:" :style="{ 'font-weight': 'bold' }">
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票抬头">
              <span>{{ form.invoiceHeaderName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抬头类型">
              <span>{{ form.type == 1 ? "企业" : "个人" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单金额">
              <span>{{ form.invoiceAmount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型">
              <span>电子普通发票</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-row :gutter="40">
            <el-col :span="24">
              <el-form-item label="联系信息:" :style="{ 'font-weight': 'bold' }">
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="真实姓名">
              <span>{{ form.receiver }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <span>{{ form.linkPhone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="联系邮箱">
              <span>{{ form.email }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="开票状态">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">开票中</el-radio>
                <el-radio :label="2">已开票</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="发票编号">
              <el-input v-model="form.invoiceCode"></el-input>

            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="发票备注">
              <el-input type="textarea" v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleInvoiceConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 订单弹窗 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible1" width="50%" @close="handleClose">
      <div v-for="(item, index) in orderList" :key="index">
        <el-form :model="item" label-width="120px">
          <el-row :gutter="20">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="收货信息：" style="font-weight: bold" label-style="{'font-weight': 'bold'}">
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="用户昵称">
                <span>{{ item.memberName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="收货人">
                <span>{{ item.recipientName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="联系电话">
                <span>{{ item.recipientPhone }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="站点地址" v-if="item.orderType == 2">
                <span>{{ item.siteName }}</span>
              </el-form-item>
              <el-form-item label="收货地址" v-else>
                <span>{{ item.expressAddress }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="订单信息：" style="font-weight: bold" label-style="{'font-weight': 'bold'}">
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="订单号">
                <span>{{ item.orderNumber }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="订单状态">
                <span>{{ orderStatusMap[item.orderStatus] }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="商品总数">
                <span>{{ getAllCount(item.orderItems) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="订单备注">
                <span>{{ item.remark }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="配送费">
                <span>{{ item.teamFee }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="商品总价">
                <span>{{ item.orderAmount }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="优惠券金额">
                <span>{{ item.couponAmount }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="会员商品优惠">
                <span>{{ item.vipSaveBalance }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="积分抵扣">
                <span>{{ item.useScore ? item.useScore : 0 }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="实际支付">
                <span>{{ item.actualAmount }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="创建时间">
                <span>{{ item.orderTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="支付方式">
                <span>{{ payTypeMap[item.payType] }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item label="商家备注:"> </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
        <el-table :data="item.orderItems" style="width: 100%" border :header-cell-style="{
          'background-color': '#f2f2f2',
          'text-align': 'center',
          border: '1px solid #ddd',
        }">
          <el-table-column label="商品图片" align="center" width="150">
            <template slot-scope="scope">
              <el-image style="width: 50px; height: 50px" :src="scope.row.listImg"
                        :preview-src-list="[scope.row.skuImg]">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>

          <el-table-column prop="teamPicture" label="商品名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.productName }}</template>
          </el-table-column>

          <el-table-column prop="teamPicture" label="规格名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.skuName }}</template>
          </el-table-column>

          <el-table-column prop="teamPicture" label="商品分类" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{
                scope.row.categoryFirstName
              }}
            </template>
          </el-table-column>
          <el-table-column prop="teamPicture" label="商品售价" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.sellPrice }}</template>
          </el-table-column>
          <el-table-column prop="teamPicture" label="商品数量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.count }}</template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取消</el-button>
        <el-button type="primary">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataRange: '',
      dialogVisible: false,
      dialogVisible1: false,
      allNumObj: {},
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 10,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      tableData1: [],
      detail: {},
      tableData: [],
      orderList: [],
      height: window.innerHeight - 256, // 表格高度
      headerHeight: 0,
      activeName: null,
      loading: false,
      orderStatusMap: {
        1: '待司机装车',
        2: '待司机配送',
        3: '司机配送中',
        4: '司机已送达',
        5: '待用户核销',
        6: '待团长配送',
        7: '已完成',
        8: '已评价'
      },
      payTypeMap: {
        1: '微信',
        2: '支付宝',
        3: '余额',
        4: '储值卡组合支付',
        '1, 5': '微信加积分',
        '1, 3': '微信加余额',
        '1, 4': '微信加储值卡',
        '2, 5': '支付宝加积分',
        '2, 3': '支付宝加余额',
        '2, 4': '支付宝加储值卡',
        '3, 5': '余额加积分',
        '4, 5': '储值卡加积分',
        6: '公司员工额度支付'
      }
    }
  },

  created() {
    this.getList()
    this.getAllNum()
  },

  mounted() {
  },
  methods: {
    // 商品总数
    getAllCount(list) {
      let count = 0
      list.forEach((item) => {
        count += item.count
      })
      return count
    },

    handleClick(val) {
      this.queryInfo.condition.status = val.name
      this.getList()
    },

    orderStatusChange() {
    },
    // 导出
    async toExport(row) {
      const loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const res = await this.$http.post('/exportExcel/exportInvoice', {invoiceCode: row.invoiceCode},
        {responseType: 'blob'})
      if (res.status == 200) {
        try {
          const fileUrl = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = fileUrl
          link.target = '_blank'
          link.setAttribute('download', `发票数据表格.xls`) // 设置导出的文件名称
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          loading.close()
          this.$message({type: 'success', message: '导出成功'})
        } catch (error) {
          this.$message.error(error)
        }
      }
    },
    changeTime(data) {
      if (data) {
        this.queryInfo.condition.startTime = data[0]
        this.queryInfo.condition.endTime = data[1]
      } else {
        this.queryInfo.condition.startTime = ''
        this.queryInfo.condition.endTime = ''
      }
      this.getList()
    },
    // 审核状态
    getAllNum() {
      let _this = this
      this.$http
        .post('/memberInvoice/queryInvocieStatus', {})
        .then((response) => {
          console.log(response)
          if (response.data.code == 200) {
            _this.allNumObj = response.data.data
          }
        })
    },
    async edit(invoiceCode) {
      var that = this
      that.dialogVisible = true
      const response = await that.$http.post(
        '/memberInvoice/queryInvoiceDetail',
        {
          invoiceCode: invoiceCode
        }
      )
      if (response.data.code == 200) {
        that.form = response.data.data
      }
    },
    handleInvoiceConfirm() {
      this.$http.post('/memberInvoice/update', this.form).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          })
          this.dialogVisible = false
          this.getList()
        } else {
          this.$message({
            message: res.data.message,
            type: 'fail'
          })
        }
      })
    },

    async orderListdetail(invoiceCode) {
      this.dialogVisible1 = true
      this.$http
        .post('/memberInvoiceOrder/queryOrderListDetail', {
          invoiceCode: invoiceCode
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.orderList = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              type: 'fail'
            })
          }
        })
    },

    // async deta(orderNumber) {
    //   var that = this;
    //   that.dialogVisible1 = true;
    //   const response = await that.$http.post("/order/queryOrderDetail", {
    //     orderNumber: orderNumber,
    //   });
    //   console.log(response.data.data);
    //   if (response.data.code == 200) {
    //     that.detail = response.data.data;
    //     that.tableData1 = that.detail.orderItems;
    //   }
    // },

    // 获取数据
    async getList() {

      this.loading = true
      const res = await this.$http.post("memberInvoice/list", this.queryInfo)
      console.log(res, 618)
      if (res.data.code == 200) {
        this.loading = false
        this.total = res.data.data.count
        this.queryInfo.currPage = res.data.data.currPage
        this.tableData = res.data.data.data
      }

      // console.log(111,615)
      // var that = this
      // that.loading = true
      // that.$http
      //   .post('/memberInvoice/list', that.queryInfo)
      //   .then(function (response) {
      //     console.log(response.data.data)
      //     if (response.data.code == 200) {
      //       that.loading = false
      //       that.total = response.data.data.count
      //       that.queryInfo.currPage = response.data.data.currPage
      //       that.tableData = response.data.data.data
      //     }
      //   })
    },

    search() {
      this.queryInfo.currPage = 1
      this.getList()
    },
    reset() {
      this.queryInfo.condition = {}
      this.dataRange = ''
      this.getList()
    },
    handleClose(done) {
      // 如果需要在关闭前执行某些操作，可以在这里添加逻辑
      done()
    },

    // 切换日期
    handleDateChange() {
    },
    // 修改页数大小
    handleSizeChange(val) {
      this.queryInfo.pageSize = val
      this.getList()
    },
    // 获取当前页面
    handleCurrentChange(val) {
      this.queryInfo.currPage = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.view-box {
  flex: 1;
  /* height: 540px; */
  min-height: 540px;
  max-height: calc(85vh - 180px);
  overflow-y: auto;

  .imgli {
    flex: 1;

    img {
      width: 100%;
      object-fit: contain;
    }
  }
}

.el-tabs__header {
  margin: 0;
}

.box {
  .search {
    background-color: #fff;
    box-sizing: border-box;
    padding: 15px 15px;

    .search-top {
      padding: 5px;
      background-color: rgba(30, 152, 215, 0.14);
      font-size: 15px;
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      div {
        width: 150px;
        text-align: center;
      }
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .tab {
    background-color: #fff;
    //margin-top: 15px;
    //padding: 15px;
  }

  .add {
    height: 33px;
    padding: 2px 2px 2px 2px;
    background-color: rgba(30, 152, 215, 0.14);

    display: flex;
    align-items: center;
    margin-bottom: 10px;

    div {
      width: 150px;
      text-align: center;
    }
  }

  .dia {
    .diafour {
      display: flex;
      justify-content: space-between;
      padding: 20px 130px;
    }
  }

  .drawer {
    height: 900px;
    overflow-y: scroll;
    font-size: 12px;

    .drwtop {
      display: flex;
      flex-wrap: wrap;
      padding: 0 20px;

      div {
        width: 300px;
        color: #000;
        height: 50px;

        span {
          color: #494848;
        }
      }
    }

    .draimg {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      padding: 0 30px;

      .imgbox2 {
        width: 100%;

        .imgname {
          color: #000;
        }

        .img {
          margin-top: 10px;
          display: flex;

          img {
            width: 89px;
            height: 65px;
          }
        }
      }

      .imgbox {
        width: 30%;
        display: flex;

        .imgname {
          color: #000;
        }

        .img {
          margin-top: 10px;
          display: flex;

          img {
            width: 89px;
            height: 65px;
          }
        }
      }
    }

    .bl {
      padding: 0 30px;

      .bl-li {
        display: flex;
        align-items: center;
        margin-top: 5px;

        .bls {
          display: flex;
          align-items: center;
          margin-left: 15px;

          input {
            width: 100px;
            height: 32px;
            text-align: center;
          }

          .text-box {
            width: 38px;
            height: 38px;
            background-color: rgba(230, 230, 230, 0.55);
            text-align: center;
            line-height: 38px;
          }
        }
      }
    }

    .d-config {
      display: flex;
      margin-bottom: 10px;
      /* height: 540px; */
      flex-direction: column;
      padding-right: 60px;
      font-size: 12px;

      .qx {
        padding: 0 64px;
        box-sizing: border-box;
        margin-top: 8px;
        width: 100%;

        .el-switch {
          padding: 0 8px;
        }

        .qx-item {
          padding: 5px 0;
        }
      }

      .title1 {
        color: #4e4848;
        padding-left: 30px;
      }

      .title2 {
        color: #847575;
        padding-left: 46px;
      }
    }
  }

  .diatwo {
    box-sizing: border-box;
    padding: 0 30px;

    .dialist {
      display: flex;
      flex-wrap: wrap;

      .dia-li {
        width: 300px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .name {
          font-weight: 700;
          margin-right: 20px;
        }

        img {
          width: 48px;
          height: 47px;
        }
      }
    }

    .diaimg {
      display: flex;
      flex-wrap: wrap;

      .imgbox {
        width: 300px;
        margin-bottom: 15px;

        .name {
          font-weight: 700;
        }

        .imgli {
          display: flex;
          margin-top: 15px;

          img {
            width: 92px;
            height: 65px;
            margin-right: 10px;
          }
        }
      }
    }

    .sh {
      display: flex;
      margin-top: 40px;

      textarea {
        width: 679px;
        height: 60px;
        margin-left: 10px;
      }
    }

    .but {
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      padding: 0 300px;
    }
  }
}

.el-switch__label * {
  font-size: 12px;
}

.e {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px;
  display: inline-block;
}

.bl-li {
  display: flex;
  align-items: center;
  margin-top: 5px;

  .bls {
    display: flex;
    align-items: center;
    margin-left: 15px;

    input {
      width: 100px;
      height: 32px;
      text-align: center;
    }

    .text-box {
      width: 38px;
      height: 38px;
      background-color: rgba(230, 230, 230, 0.55);
      text-align: center;
      line-height: 38px;
    }
  }
}

.setform {
  padding: 0 20px 0 40px;
}
</style>
